import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, WhyUs, NewsletterSection, Features, Clients, Team, Process, Calculator, HomeBanner, CaseSection, CCTVSolutions } from '../../sections';
import SystemFeatures from './SystemFeatures/SystemFeatures';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Hero section with a call-to-action */}
      <Features /> {/* Features Section */}
      <About /> {/* About the company */}
      <Counter /> {/* Company stats and achievements */}
      <CCTVSolutions />
      <Services /> {/* Services offered */}
      <WhyUs /> {/* Why Choose Us section */}
      <SystemFeatures /> {/* Served Industries Section */}
      <HomeBanner />
      <Process /> {/* Process slider section */}
      <Testimonials /> {/* Client reviews */}
      <Team /> {/* Team section */}
      <Calculator /> {/* Served Industries Section */}
      <CaseSection /> {/* Project Section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Section */}
    </div>
  )

}

export default HomePage;